module.exports = __webpack_public_path__ + "VIPV1.png?031ccfa3702fc622243686e8f33abed3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV1.png
// module id = 103
// module chunks = 0